/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Limit_Upgrade_ButtonInputs */



/**
* | output |
* | --- |
* | "Upgrade plan" |
*
* @param {Members_Limit_Upgrade_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_limit_upgrade_button = /** @type {((inputs?: Members_Limit_Upgrade_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Limit_Upgrade_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Plan upgraden")
	return /** @type {LocalizedString} */ ("Upgrade plan")
});